import React, { useState } from "react";
import { FaTimes, FaCreditCard, FaMobile } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { payOrder } from "../actions/ordersActions";
import formatMoney from "./formatMoney";
import "../styles/paymentmodal.css";

const PaymentModal = ({ isOpen, onClose, order, onPaymentSuccess }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { paymentLoading, paymentData, error } = useSelector(
    (state) => state.orders
  );
  const [paymentMethod, setPaymentMethod] = useState(null);

  if (!isOpen || !order) return null;

  const handleMobileMoneyPayment = () => {
    setPaymentMethod("mobile_money");
  };

  const handleCardPayment = async () => {
    try {
      const result = await dispatch(payOrder(order.order_id));

      if (result.status === "success") {
        // Open payment URL in a new tab
        window.open(result.data.payment_url, "_blank");
        onPaymentSuccess && onPaymentSuccess(result);
        // Close the modal after redirecting
        handleClose();
      }
    } catch (err) {
      // Error is handled by Redux state
      console.error("Payment initialization failed:", err);
    }
  };

  const handleClose = () => {
    setPaymentMethod(null);
    onClose();
  };

  const renderMobileMoneyInstructions = () => (
    <div className="mobile-money-instructions">
      <div className="payment-method-header">
        <FaMobile className="payment-icon" />
        <h3>Mobile Money Payment</h3>
      </div>
      <div className="momo-code-section">
        <span className="momo-label">MTN Mobile Money Code:</span>
        <span className="momo-code">*182*8*1*052158#</span>
        <span className="merchant-name">SONG & STARK COOPERATION</span>
      </div>
      <div className="payment-amount-info">
        <p className="amount-label">Amount to Pay:</p>
        <p className="amount-value">
          {formatMoney(order.final_total || order.total_price)}
        </p>
      </div>
      <div className="payment-instructions-footer">
        <p className="payment-note">
          Please complete the payment using the USSD code above to process your
          order.
        </p>
        <button
          onClick={() => navigate("/contactus")}
          className="contact-support-btn"
        >
          Need Help? Contact Support
        </button>
      </div>
    </div>
  );

  const renderPaymentMethodSelection = () => (
    <div className="payment-method-selection">
      <h3>Choose Payment Method</h3>
      <div className="payment-methods">
        <button
          className="payment-method-btn mobile-money-btn"
          onClick={handleMobileMoneyPayment}
        >
          <FaMobile className="method-icon" />
          <div className="method-info">
            <span className="method-name">Mobile Money</span>
            <span className="method-description">
              Pay with MTN Mobile Money
            </span>
          </div>
        </button>
        <button
          className="payment-method-btn card-btn"
          onClick={handleCardPayment}
          disabled={paymentLoading}
        >
          <FaCreditCard className="method-icon" />
          <div className="method-info">
            <span className="method-name">Card Payment</span>
            <span className="method-description">
              {paymentLoading ? "Processing..." : "Pay with Credit/Debit Card"}
            </span>
          </div>
        </button>
      </div>
    </div>
  );

  return (
    <div className="payment-modal-overlay" onClick={handleClose}>
      <div className="payment-modal" onClick={(e) => e.stopPropagation()}>
        <div className="payment-modal-header">
          <h2>Complete Payment</h2>
          <button className="close-btn" onClick={handleClose}>
            <FaTimes />
          </button>
        </div>

        <div className="payment-modal-content">
          <div className="order-summary-section">
            <h4>Order Summary</h4>
            <div className="order-info">
              <p>
                <strong>Order ID:</strong> {order.order_id}
              </p>
              <p>
                <strong>Total Amount:</strong>{" "}
                {formatMoney(order.final_total || order.total_price)}
              </p>
              {order.applied_coupon_code && (
                <p>
                  <strong>Coupon Applied:</strong> {order.applied_coupon_code}
                </p>
              )}
            </div>
          </div>

          {error && (
            <div className="payment-error">
              <p>{error}</p>
            </div>
          )}

          {!paymentMethod
            ? renderPaymentMethodSelection()
            : renderMobileMoneyInstructions()}
        </div>

        {paymentMethod && (
          <div className="payment-modal-footer">
            <button className="back-btn" onClick={() => setPaymentMethod(null)}>
              Back to Payment Methods
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentModal;
